import { BookRepository } from "@/repositories/book";
export const BOOK = Symbol('book');
export default {
    [BOOK]: new BookRepository()
};
